export default __webpack_public_path__ + "static/media/evenshot.22994ccb.png";